import React from 'react';
import RoofCalculatorForm from './components/PriceCalculatorForm';
import CacheBuster from 'react-cache-buster';
import packageJson from '../package.json';

function App() {
    const doBustCache = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'test';
    // App's own folder (e.g. /kalkulacia-ceny) - on prod the site root serves the CZ build's meta.json
    const metaFileDirectory = new URL('.', window.location.href).pathname.replace(/\/$/, '');

    return (
        <CacheBuster
            currentVersion={packageJson.version}
            isEnabled={doBustCache}
            isVerboseMode={false}
            metaFileDirectory={metaFileDirectory}
        >
            <div className="App">
                <RoofCalculatorForm />
            </div>
        </CacheBuster>
    );
}

export default App;